<template>
  <div class="picker">
    <h2>
      {{ !showCodePicker ? title : codePickerTitle }}
    </h2>
    <div v-if="showDownloadAppLinks" class="download-app">
      <p>{{ $t('start_learning.download_elsa_app') }}</p>
      <div id="links">
        <a href="https://play.google.com/store/apps/details?id=us.nobarriers.elsa" target="_blank">
          <img src="@/assets/images/download-google.svg" />
        </a>
        <a href="https://apps.apple.com/us/app/elsa-speak-accent-reduction/id1083804886" target="_blank">
          <img src="@/assets/images/download-app-store.svg" />
        </a>
      </div>
    </div>
    <p
      v-if="options.length > 0"
    >
      {{ subtitle }}
    </p>
    <div v-if="!showCodePicker" class="options">
      <div
        v-for="(option, idx) in options"
        :key="idx"
        :class="`option ${!hiddenOption(option) ? 'hidden' : ''}`"
      >
        <input
          type="radio"
          :id="option.input"
          :value="option.input"
          v-model="picked"
          @change="activateOption"
        />
        <img :src="getImage(option.image)" :alt="option.name" />
        <span>{{ option.name }}</span>
        <span v-if="option.subtitle" id="subtitle">{{ option.subtitle }}</span>
      </div>
    </div>
    <code-picker v-else @confirmedCodePicker="handleCodePicker"/>
    <primary-button
      v-if="!showCodePicker && options.length > 0"
      ref="continue"
      @click.native="onClickContinue"
      class="bigger"
      disabled
    >
      {{ buttonText }}
    </primary-button>
  </div>
</template>

<script>
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import CodePicker from '@/components/teachers/CodePicker'
  import { handleSubmitButtonState } from '@/helpers/formValidationHelper'

  export default {
    components: {
      PrimaryButton,
      CodePicker
    },
    props: {
      options: {
        type: Array,
        default: () => []
      },
      title: {
        type: String,
        default: ''
      },
      subtitle: {
        type: String,
        default: ''
      },
      buttonText: {
        type: String,
        default: ''
      },
      codePickerTitle: {
        type: String,
        default: ''
      },
      codePickerAvailable: {
        type: Boolean,
        default: false
      },
      showDownloadAppLinks: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        picked: '',
        showCodePicker: false
      }
    },
    methods: {
      getImage(image) {
        return require(`@/assets/images/${image}`)
      },
      activateOption(e) {
        const elementClasses = e.target.parentElement.classList
        if (!elementClasses.contains('active')) {
          const options = document.getElementsByClassName('option')
          for(let option of options) {
            option.classList.remove('active')
          }
          elementClasses.add('active')
          handleSubmitButtonState(this.$refs.continue.$el, true)
        }
      },
      onClickContinue() {
        if (this.codePickerAvailable && this.picked === 'yes' ) {
          this.showCodePicker = true
        } else {
          this.$emit('continueEvent', this.picked)
        }
      },
      hiddenOption(option) {
        return option.isVisible !== undefined ? option.isVisible : true
      },
      handleCodePicker(code) {
        this.$emit('continueEvent', code)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_colors.scss';

  .picker {
    display: flex;
    flex-direction: column;
    p {
      margin-top: 16px;
      font-size: 18px;
      color: $dark-blue-2;
      line-height: 1;
      text-align: initial;
    }
    button {
      align-self: baseline;
      margin-top: 40px;
    }
    .download-app {
      display: flex;
      flex-direction: column;
      margin-top: 5px;
      margin-bottom: 35px;
      #links {
        display: flex;
        a {
          margin-right: 3px;
          height: 58px;
          &:last-of-type {
            padding-top: 5px;
          }
        }
      }
    }
    .options {
      display: grid;
      grid-template-columns: 202px 202px 202px 202px;
      grid-column-gap: 32px;
      margin-top: 4px;
      .option {
        border: 2px solid transparent;
        background-color: $lighter-gray;
        padding: 40px 20px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        &.hidden {
          display: none;
        }
        img {
          margin-bottom: 31px;
          width: 122px;
          height: 122px;
        }
        span {
          font-size: 18px;
          color: $dark-gray;
          text-transform: uppercase;
          font-weight: 600;
          &#subtitle {
            font-family: 'SF Pro Display';
            font-weight: normal;
            color: $dark-blue-2;
            text-transform: none;
          }
        }
        input {
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          z-index: 111;
        }
        &.active {
          border: 2px solid $purple;
        }
      }
    }
  }

</style>
